// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen.js';
/**
 * Get API version
 *
 * Retrieve the current version of the API. The breaking changes may occur only between major versions (e.g., 1.x.x to 2.x.x). It's client's responsibility to ensure compatibility with the API version.
 *
 */
export const getVersion = (options) => (options?.client ?? client).get({ url: '/version', ...options });
/**
 * Submit telemetry data
 *
 * Collect telemetry data from clients for analysis and monitoring.
 *
 * Warning: while this method is allowed to be called directly from client-side code, both sides should not include
 * any sensitive information (such as secrets or server internal data) in the request or response.
 *
 * Note: payload format is not strictly defined yet, but will likely be specified in future versions.
 *
 */
export const submitTelemetry = (options) => (options.client ?? client).post({
    url: '/telemetry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Emit a new payload token
 *
 * Generate and return a new token for a given payload. Tokens can be used to trustfully transfer initial payloads via URL parameters or client-side code.
 *
 */
export const emitPayloadToken = (options) => (options.client ?? client).post({
    security: [{ name: 'X-API-KEY', type: 'apiKey' }],
    url: '/token/emit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Trigger an action based on a specific event in the UI, process it using downstream systems, and return a command to be executed by the client
 *
 *
 * Warning: while this method is allowed to be called directly from client-side code, both sides should not include any sensitive information (such as secrets or server internal data) in the request or response.
 *
 */
export const triggerAction = (options) => (options.client ?? client).post({
    security: [{ name: 'X-API-KEY', type: 'apiKey' }],
    url: '/triggerAction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
